const STORAGE_KEY = 'guru.preferences.v1'

const DEFAULTS = {
  showCriticalPeeks: true,
  showMediumBadge: true,
  showInfoCards: true,
}

export function readGuruPreferences() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return DEFAULTS
    const parsed = JSON.parse(raw)
    return {
      showCriticalPeeks: parsed.showCriticalPeeks ?? DEFAULTS.showCriticalPeeks,
      showMediumBadge:   parsed.showMediumBadge   ?? DEFAULTS.showMediumBadge,
      showInfoCards:     parsed.showInfoCards     ?? DEFAULTS.showInfoCards,
    }
  } catch (_) {
    return DEFAULTS
  }
}

export function writeGuruPreferences(prefs) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
  } catch (_) {}
}
